import * as FeatureHubReact from '@feature-hub/react';
import * as react from 'react';

export const externals = {
  react: react,
  '@feature-hub/react': FeatureHubReact,
};
